<template>
  <section
    v-if="stats"
    class="conversion-summary"
    aria-label="Conversion results"
  >
    <div class="conversion-summary-grid">
      <div>
        <span>Conversions</span><strong>{{ stats.total_conversions }}</strong
        ><small>Of {{ stats.total_leads }} leads in this period</small>
      </div>
      <div>
        <span>Conversion rate</span
        ><strong>{{ percent(stats.conversion_rate) }}</strong
        ><small>Converted / total leads</small>
      </div>
      <div>
        <span>Collected revenue</span
        ><strong>{{ money(stats.collected_revenue) }}</strong
        ><small>{{
          stats.missing_revenue_leads
            ? stats.missing_revenue_leads + ' converted leads need revenue'
            : stats.revenue_unavailable_reason || 'Payments minus refunds'
        }}</small>
      </div>
      <div>
        <span>ROI (ad spend)</span
        ><strong>{{ percent(stats.ad_spend_roi) }}</strong
        ><small>{{
          stats.roi_unavailable_reason ||
          '(Collected revenue − ad spend) / ad spend'
        }}</small>
      </div>
    </div>
    <p>
      Conversions come from the GHL <b>converted</b> tag or a manual update.
      Revenue is entered separately. ROI excludes operating costs. Trends group
      results by the date the lead was created.
    </p>
  </section>
</template>
<script>
export default {
  props: { stats: { type: Object, default: null } },
  methods: {
    percent(value) {
      return value == null ? '—' : Number(value).toFixed(2) + '%'
    },
    money(value) {
      return value == null
        ? '—'
        : new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: this.stats.currency || 'USD',
          }).format(value)
    },
  },
}
</script>
<style scoped>
.conversion-summary {
  margin: 16px 0 24px;
}
.conversion-summary-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}
.conversion-summary-grid > div {
  background: white;
  border: 1px solid #dce5eb;
  border-radius: 12px;
  padding: 18px;
}
.conversion-summary span,
.conversion-summary strong,
.conversion-summary small {
  display: block;
}
.conversion-summary span {
  font-size: 12px;
  font-weight: 700;
  color: #536579;
}
.conversion-summary strong {
  font-size: 28px;
  line-height: 1.5;
  color: #16283c;
}
.conversion-summary small,
.conversion-summary p {
  font-size: 12px;
  color: #637487;
  line-height: 1.6;
}
.conversion-summary p {
  margin: 10px 0 0;
}
@media (max-width: 900px) {
  .conversion-summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 480px) {
  .conversion-summary-grid {
    grid-template-columns: 1fr;
  }
}
</style>
